module.exports = __webpack_public_path__ + "media/assets/faria_products/AN-SL-9eb681d15f102e803b1ad6f6076918575f7f0d3b92103370db5bd407f5007c2a.png";